module.exports = __webpack_public_path__ + "static/media/ezgif.com-webp-to-png.0a4b935f.png";